/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsCustomListField } from './WebApiModelsCustomListField';
import {
    WebApiModelsCustomListFieldFromJSON,
    WebApiModelsCustomListFieldFromJSONTyped,
    WebApiModelsCustomListFieldToJSON,
} from './WebApiModelsCustomListField';

/**
 * 
 * @export
 * @interface WebApiCustomListFieldsDtoSaveCustomFieldSettingsDto
 */
export interface WebApiCustomListFieldsDtoSaveCustomFieldSettingsDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListFieldsDtoSaveCustomFieldSettingsDto
     */
    listId?: number;
    /**
     * 
     * @type {Array<WebApiModelsCustomListField>}
     * @memberof WebApiCustomListFieldsDtoSaveCustomFieldSettingsDto
     */
    fields?: Array<WebApiModelsCustomListField> | null;
}

/**
 * Check if a given object implements the WebApiCustomListFieldsDtoSaveCustomFieldSettingsDto interface.
 */
export function instanceOfWebApiCustomListFieldsDtoSaveCustomFieldSettingsDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiCustomListFieldsDtoSaveCustomFieldSettingsDtoFromJSON(json: any): WebApiCustomListFieldsDtoSaveCustomFieldSettingsDto {
    return WebApiCustomListFieldsDtoSaveCustomFieldSettingsDtoFromJSONTyped(json, false);
}

export function WebApiCustomListFieldsDtoSaveCustomFieldSettingsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiCustomListFieldsDtoSaveCustomFieldSettingsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'listId': !exists(json, 'listId') ? undefined : json['listId'],
        'fields': !exists(json, 'fields') ? undefined : (json['fields'] === null ? null : (json['fields'] as Array<any>).map(WebApiModelsCustomListFieldFromJSON)),
    };
}

export function WebApiCustomListFieldsDtoSaveCustomFieldSettingsDtoToJSON(value?: WebApiCustomListFieldsDtoSaveCustomFieldSettingsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'listId': value.listId,
        'fields': value.fields === undefined ? undefined : (value.fields === null ? null : (value.fields as Array<any>).map(WebApiModelsCustomListFieldToJSON)),
    };
}

